import { Mapper } from "lib/api";
import { Sector, SectorDTO } from "models";

// first param is the DTO, second param is the class
export class SectorMapper extends Mapper<SectorDTO, Sector> {
	constructor() {
		super(Sector); // Pass the target class constructor
	}

	// Override only if you need custom mapping logic beyond plainToClass
	// protected override customMapping(source: SectorDTO, target: Sector): Sector {
	// 	return target
	// }
}

export function New(): SectorMapper {
	return new SectorMapper();
}
